<template>
	<div>
		<hr />
		<h5>
			<strong>{{ $t('MAIN_CONTENT.BuildingInformation.buildingInformation') }}</strong>
		</h5>
		<br />
		<div class="row">
			<div class="col-sm-4" v-if="!!buildingInformation.PHONE_NUMBER">
				<strong>
					{{ $t('MAIN_CONTENT.BuildingInformation.phoneWithColon') }}
				</strong>
				<br />
				{{ buildingInformation.PHONE_NUMBER }}
			</div>
			<div class="col-sm-4" v-if="!!buildingInformation.FAX_NUMBER">
				<strong>
					{{ $t('MAIN_CONTENT.BuildingInformation.faxWithColon') }}
				</strong>
				<br />
				{{ buildingInformation.FAX_NUMBER }}
			</div>
			<div class="col-sm-4" v-if="!!buildingInformation.ADDRESS_1 || !!buildingInformation.CITY || !!buildingInformation.STATE_CODE || !!buildingInformation.ZIP_CODE">
				<strong>
					{{ $t('MAIN_CONTENT.BuildingInformation.addressWithColon') }}
				</strong>
				<br />
				{{ buildingInformation.ADDRESS_1 }}
				<br />
				{{ buildingInformation.CITY }}<template v-if="!!buildingInformation.CITY && !!buildingInformation.STATE_CODE">, </template>
				{{ buildingInformation.STATE_CODE }} {{ buildingInformation.ZIP_CODE }}
				<template v-if="!!buildingInformation.ZIP_CODE_EXT">-{{ buildingInformation.ZIP_CODE_EXT }}</template>
			</div>
		</div>
		<br />
		<!-- Start of Administrator data -->
		<div class="row" v-if="adminInfo.length > 0">
			<div class="col-sm-4"
					 v-for="(administrator, idx) in adminInfo"
					 :key="`adinistrator_${buildingInformation.SCHOOL_ID}_${idx}`">
				<strong v-if="!!administrator.ADMINISTRATOR_DESC">
					{{ $t('MAIN_CONTENT.BuildingInformation.staffTitle', { title: administrator.ADMINISTRATOR_DESC } ) }}
				</strong>
				<br />
				{{ administrator.STAFF_NAME }}
			</div>
		</div>
		<!-- End of Administrator data -->
	</div>
</template>

<script>
	export default {
		name: 'BuildingInformation',
		props: {
			buildingInformation: {
				type:			Object,
				required:	true
			},
			adminInfo: {
				type: Array,
				default: function() {
					return [];
				}
			}
		}
	};
</script>
